export default __webpack_public_path__ + "locales/pl/DownloadDialog.json?hash=d5d23815eadbda8a98da2e23bd9076ac";